import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store, select } from '@ngrx/store';
import { of } from 'rxjs';
import { withLatestFrom, map, switchMap, catchError, concatMap, tap } from 'rxjs/operators';
import * as AppActions from '../actions/app.action';
import { AppState } from '../app.state';
import { CompanyService } from '../../../app/company/company.service';

interface RootState {
  app: AppState;
}

@Injectable()
export class AppEffects {
  
  checkAndLoadCompanyInfo$ = createEffect(() => 
    this.actions$.pipe(
      ofType(AppActions.loadCompanyInfo),
      withLatestFrom(
        this.store.pipe(select(state => state?.app?.selectedPRF?.prfname))
      ),
      concatMap(([action, prfname]) => {
        const actions: any[] = [
          AppActions.setCompanyInfo({
            prfnumber: action.prfnumber,
            prfname: prfname,
            prfyear: action.prfyear,
            groupcode: action.groupcode,
          })
        ];
        if (!prfname) {
          actions.push(
            AppActions.getCompanyInfo({
              groupcode: action.groupcode,
              prfnumber: action.prfnumber,
              prfyear: action.prfyear
            })
          );
        }
        
        return actions;
      })
    )
  );
  
  getCompanyInfo$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AppActions.getCompanyInfo),
      switchMap((action) => 
        this.appService.loadCompanyInformation(action.prfyear, action.prfnumber, action.groupcode).pipe(
          map((response: any) => {
            const companyData = response.companydata;
            return AppActions.setCompanyInfo({
              prfnumber: action.prfnumber,
              prfname: companyData.compname,
              prfyear: action.prfyear,
              groupcode: action.groupcode,
              prfstatus: companyData.status,
            });
          }),
          catchError(error => of(AppActions.getCompanyInfoFailure({ error })))
        )
      )
    )
  );

  redirectOnCompanyInfoFailure$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AppActions.getCompanyInfoFailure),
      tap(() => {
        this.router.navigate(['/apifailure'], { queryParams: { rf: 'notfound' } });
      })
    ),
    { dispatch: false }
  );

  constructor(
    private readonly actions$: Actions,
    private readonly store: Store<RootState>,
    private readonly appService: CompanyService,
    private readonly router: Router
  ) {}
}